import React from 'react';
import { Th, Thead, Tr, HStack, } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { tKeys } from '../../../../../../../../translations/keys';
import COLORS from '../../../../../../../../constants/colors';
import { SortBy } from '../../../../../../../../services/types';
import CustomIcon from '../../../../../../../../components/content/icon';
import CustomText from '../../../../../../../../components/content/text';
import FONTS from '../../../../../../../../constants/fonts';
export const DocumentListTableHeader = ({ orderBy, setOrderBy, optionsOrder, documentRelation, }) => {
    const { t } = useTranslation();
    const isSignatureTab = documentRelation.value === 3;
    const isGeneralTab = documentRelation.value === 2;
    const getSortIconName = (colSortByAsc, colSortByDesc) => {
        if (orderBy?.value === colSortByDesc)
            return 'chevron-up';
        if (orderBy?.value === colSortByAsc)
            return 'chevron-down';
        return 'filter-order';
    };
    const getSortIconColor = (colSortByAsc, colSortByDesc) => {
        return orderBy?.value === colSortByDesc || orderBy?.value === colSortByAsc
            ? COLORS.Text.T900.value
            : COLORS.Text.T200.value;
    };
    const handleSortClick = (colSortByAsc, colSortByDesc) => {
        if (orderBy?.value === colSortByDesc) {
            setOrderBy(optionsOrder?.find(opt => opt.value === colSortByAsc));
        }
        else {
            setOrderBy(optionsOrder?.find(opt => opt.value === colSortByDesc));
        }
    };
    return (<Thead position={'sticky'} top={0} zIndex={2} backgroundColor={COLORS.White.T500.value}>
      <Tr>
        {/* Column 1: Title (Sortable) */}
        <Th width="60%" px={3} py={1.5}>
          <HStack alignItems="center" onClick={() => handleSortClick(SortBy[3], SortBy[2])} cursor={'pointer'} spacing={1}>
            <CustomIcon name={getSortIconName(SortBy[3], SortBy[2])} width={16} height={16} stroke={getSortIconColor(SortBy[3], SortBy[2])}/>
            <CustomText color={getSortIconColor(SortBy[3], SortBy[2])} font={FONTS.T1.T12Px.Medium500.value}>
              {t(tKeys.common.title)}
            </CustomText>
          </HStack>
        </Th>

        {/* Column 2: Issued On (Sortable) */}
        <Th px={3} py={1.5}>
          <HStack alignItems="center" onClick={() => handleSortClick(SortBy[1], SortBy[0])} cursor={'pointer'} spacing={1}>
            <CustomIcon name={getSortIconName(SortBy[1], SortBy[0])} width={16} height={16} stroke={getSortIconColor(SortBy[1], SortBy[0])}/>
            <CustomText color={getSortIconColor(SortBy[1], SortBy[0])} font={FONTS.T1.T12Px.Medium500.value}>
              {t(tKeys.common.issued_on)}
            </CustomText>
          </HStack>
        </Th>

        {/* Column 3: Status (Only for Signature Tab, Not Sortable?) */}
        {isSignatureTab && (<Th textAlign="center" px={3} py={1.5} fontWeight="medium" fontSize="sm" color={COLORS.Text.T200.value}>
            {t(tKeys.common.status)}
          </Th>)}
      </Tr>
    </Thead>);
};
